import { createAction, props } from '@ngrx/store';
import { withGenesysCloudStoreNameSpace } from '../../common/action-namespace';
import { ConversationBase } from '../../conversations/common/models/conversation-base.model';
import { WorkItemIntegration } from '../models/work-item-integrations.model';

const withNameSpace = withGenesysCloudStoreNameSpace('WorkItemIntegrations');

export const initializeModule = createAction(
  withNameSpace('Initialize module')
);

export const toggleIntegrationPanelVisibility = createAction(
  withNameSpace('Toggle Integration Panel Visibility'),
  props<{ conversationId: string, integrationId: string }>()
);

export const setAllowedIntegrationPanels = createAction(
  withNameSpace('Set Allowed Integration Panels'),
  props<{ conversation: ConversationBase }>()
);

export const setAllowedIntegrationPanelsForConversation = createAction(
  withNameSpace('Set Allowed Integration Panels For Conversation'),
  props<{ conversation: ConversationBase, integrations: WorkItemIntegration[]  }>()
);
